import React from "react";
import PropTypes from "prop-types";
import "./RaikoLabelStylesheet.scss"

const RaikoLabel = (
    {
        text,
        className
    }) => {

    return (
        <label className={`labelStyle ${className}`}>{text}</label>
    )
}

RaikoLabel.propTypes = {
    text: PropTypes.string.isRequired
}


export default RaikoLabel